import type { CreativeType } from '../../../../../configs';
import type { TagSheetAd, TagSheetLineItem } from '../types';
import { resolveAdForLineItem } from '../utils/ads';
import { validateDates } from './validateDates';
import { getAdTypeValidationErrors } from './validateTypes';

export type DropError = { title: string; message: string };

/** Type/date validation for drag-and-drop; reuses existing line-item validators. */
export const validateDrop = (ad: TagSheetAd, targetLineItem: TagSheetLineItem): DropError | null => {
  const typeErrors = getAdTypeValidationErrors(ad, targetLineItem);

  if (typeErrors.creativeType) {
    return { title: 'Incompatible creative type', message: typeErrors.creativeType };
  }

  if (typeErrors.unsupportedCreativeType) {
    return { title: 'Unsupported creative type', message: typeErrors.unsupportedCreativeType };
  }

  if (typeErrors.adType) {
    const resolution = resolveAdForLineItem(ad.creative.creativeType.key as CreativeType, targetLineItem);

    if (!resolution) {
      return { title: 'Incompatible ad type', message: typeErrors.adType };
    }
  }

  const dateError = validateDates(ad, targetLineItem);

  if (dateError) {
    return { title: 'Ad date out of range', message: dateError };
  }

  return null;
};
